import { AddScheduleModal } from "./addScheduleModal/addScheduleModal";
import { EditScheduleModal } from "./editScheduleModal/editScheduleModal";
import { HolidaysModal } from "./HolidaysModal/HolidaysModal";

type Modal =
    AddScheduleModal |
    EditScheduleModal |
    HolidaysModal;

/** Modal manager. */
export class ModalManager {
    private modals: { [key: string]: Modal } = {};

    private activeModal: string | null = null;

    /**
     * Adds new modal to manager.
     * @param id Modal ID.
     * @param modal Modal instance.
     * @param title Title for modal.
     * @returns Modal instance.
     */
    public addModal(id: string, modal: Modal, title?: string): Modal {
        this.modals[id] = modal;
        this.modals[id].popup.modalComponent.label = title ?? "Новое окно";

        return this.modals[id];
    }

    /**
     * Removes modal from manager.
     * @param id Modal ID.
     */
    public removeModal(id: string): void {
        if (this.modals[id]) {
            this.modals[id].close();
            delete this.modals[id];
        }
    }

    /**
     * Opens modal.
     * @param id Modal ID.
     * @param params Modal open params.
     */
    public openModal<TModal extends Modal, TParams extends Parameters<TModal["open"]>["0"] = Parameters<TModal["open"]>["0"]>(
        id: string,
        params?: TParams,
    ): void {
        if (this.activeModal && this.activeModal !== id) {
            this.closeModal(this.activeModal);
        }

        if (this.modals[id]) {
            this.activeModal = id;
            const modal = this.modals[id] as TModal;

            // Typescript cant infer the correct type here since all modals from TModal accept different params.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
            modal.open(params as any);
        } else {
            console.error(`Модальное окно с id "${id}" не найдено.`);
        }
    }

    /**
     * Closes modal.
     * @param id Modal ID.
     */
    public closeModal(id: string): void {
        if (this.modals[id]) {
            this.modals[id].close();
            if (this.activeModal === id) {
                this.activeModal = null;
            }
        }
    }

    /**
     * Gets modal instance by ID.
     * @param id ID.
     */
    public getModal(id: string): Modal | null {
        return this.modals[id] || null;
    }
}
